export default () => ({
  open: false,
  heightSet: false,
  showLoading: false,

  hide() {
    this.open = false;
    setTimeout(() => (this.$refs.quickAddInfo.innerHTML = ""), 400);

    // Restore the original URL
    const originUrl = Alpine.store("nostoState").data.originUrl;
    if (originUrl) {
      window.history.replaceState(null, "", originUrl);
    }

    if (document.body.classList.contains("body-outfit-pdp")) {
      document.body.classList.remove("body-outfit-pdp");
    }
  },

  show(productUrl, isOutfit) {
    console.log("Quick Shop Show Method - Full Details:", {
      nostoState: Alpine.store("nostoState").data,
    });

    //Class for correct height
    if (isOutfit && !document.body.classList.contains("body-outfit-pdp")) {
      document.body.classList.add("body-outfit-pdp");
    }

    let body = document.querySelector("body");
    this.showLoading = true;

    // Get Nosto state data
    const nostoState = Alpine.store("nostoState").data;

    // Update store with new product URL
    Alpine.store("nostoState").set({
      ...nostoState,
      productUrl: productUrl,
      originUrl: window.location.href,
    });

    // Trigger Nosto View Product event
    if (nostoState.attributionKey && typeof nostojs === "function") {
      nostojs((api) => {
        api
          .createRecommendationRequest()
          .setProducts(
            [{ product_id: nostoState.productId }],
            nostoState.attributionKey
          )
          .load({ skipPageViews: true });
      });
    }

    if (body.classList.contains("modal-open")) {
      setTimeout(() => this.fetch(productUrl), 300);
    } else {
      this.fetch(productUrl);
    }
  },

  fetch(productUrl) {
    this.open = true;
    this.$refs.shopTheLook.style.maxHeight = "1200px";

    productUrl += "?section_id=main-product";

    console.log("Fetching product URL:", productUrl);
    fetch(productUrl)
      .then((response) => response.text())
      .then((responseText) => {
        const responseHTML = new DOMParser().parseFromString(
          responseText,
          "text/html"
        );
        this.productElement = responseHTML.querySelector(
          'section[id^="MainProduct-"]'
        );
        this.preventDuplicatedIDs();
        this.removeDOMElements();
        this.setInnerHTML(
          this.$refs.quickAddInfo,
          this.productElement.innerHTML
        );
        this.showLoading = false;

        // this.setHeight();

        // if(window.innerWidth < 768 ) {
        //   setTimeout(() => this.setHeight(), 100);
        // }

        if (window.Shopify && Shopify.PaymentButton) {
          Shopify.PaymentButton.init();
        }

        if (window.ProductModel) window.ProductModel.loadShopifyXR();

        this.preventVariantURLSwitching(this.$refs.quickAddInfo);
      })
      .finally(() => {
        // loading
      });
  },

  quickShopVariantSelect(productUrl) {
    fetch(productUrl)
      .then((response) => response.text())
      .then((responseText) => {
        const responseHTML = new DOMParser().parseFromString(
          responseText,
          "text/html"
        );
        this.productElement = responseHTML.querySelector(
          'section[id^="MainProduct-"]'
        );
        this.preventDuplicatedIDs();
        this.removeDOMElements();
        this.$refs.quickAddInfo.innerHTML = "";
        this.setInnerHTML(
          this.$refs.quickAddInfo,
          this.productElement.innerHTML
        );

        if (window.Shopify && Shopify.PaymentButton) {
          Shopify.PaymentButton.init();
        }

        if (window.ProductModel) window.ProductModel.loadShopifyXR();

        this.preventVariantURLSwitching(this.$refs.quickAddInfo);
      })
      .finally(() => {
        // loading
      });
  },

  setInnerHTML(element, html) {
    element.innerHTML = html;

    // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
    element.querySelectorAll("script").forEach((oldScriptTag) => {
      const newScriptTag = document.createElement("script");
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  },

  preventVariantURLSwitching(opener) {
    opener
      .querySelector("variant-radios,variant-selects")
      .setAttribute("data-update-url", "false");
  },

  removeDOMElements() {
    const pickupAvailability = this.productElement.querySelector(
      "pickup-availability"
    );
    if (pickupAvailability) pickupAvailability.remove();

    const productModal = this.productElement.querySelector("product-modal");
    if (productModal) productModal.remove();
  },

  preventDuplicatedIDs() {
    const sectionId = this.productElement.dataset.section;
    this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(
      sectionId,
      `quickadd-${sectionId}`
    );
    this.productElement
      .querySelectorAll("variant-selects, variant-radios")
      .forEach((variantSelect) => {
        variantSelect.dataset.originalSection = sectionId;
      });
  },

  removeGalleryListSemantic() {
    const galleryList = this.modalContent.querySelector(
      '[id^="Slider-Gallery"]'
    );
    if (!galleryList) return;

    galleryList.setAttribute("role", "presentation");
    galleryList
      .querySelectorAll('[id^="Slide-"]')
      .forEach((li) => li.setAttribute("role", "presentation"));
  },

  updateImageSizes() {
    const product = this.modalContent.querySelector(".product");
    const desktopColumns = product.classList.contains("product--columns");
    if (!desktopColumns) return;

    const mediaImages = product.querySelectorAll(".product__media img");
    if (!mediaImages.length) return;

    let mediaImageSizes =
      "(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)";

    if (product.classList.contains("product--medium")) {
      mediaImageSizes = mediaImageSizes.replace("715px", "605px");
    } else if (product.classList.contains("product--small")) {
      mediaImageSizes = mediaImageSizes.replace("715px", "495px");
    }

    mediaImages.forEach((img) => img.setAttribute("sizes", mediaImageSizes));
  },

  toggleBodyClass(addBodyClass) {
    let body = document.querySelector("body");
    if (addBodyClass) {
      if (!body.classList.contains("modal-open")) {
        body.classList.add("modal-open");
      }
    } else {
      body.classList.remove("modal-open");
    }
  },

  setHeight() {
    let offset = Alpine.store("quickShopSource").source ? 52 : 22;
    this.$refs.shopTheLook.style.height = `${
      this.$refs.quickAddInfo.offsetHeight + offset
    }px`;
  },

  checkTemplate() {
    if (!document.body.classList.contains("product.outfit")) {
      document.body.classList.remove("body-outfit-pdp");
      Alpine.store("quickShopSource").set(null);
    }
  },
});
